import { render } from "./QuestionnaireLotteryPage.vue?vue&type=template&id=25233f4e&scoped=true"
import script from "./QuestionnaireLotteryPage.vue?vue&type=script&lang=js"
export * from "./QuestionnaireLotteryPage.vue?vue&type=script&lang=js"

import "./QuestionnaireLotteryPage.vue?vue&type=style&index=0&id=25233f4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25233f4e"]])

export default __exports__